import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  closeFilter: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  resetFilters: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  selectedFiltersLength: number;
};

export class SearchMobileHeader extends React.Component<Props> {
  render() {
    const { closeFilter, selectedFiltersLength, resetFilters } = this.props;
    return (
      <div className="search-aside-header">
        <i
          className="material-icons icons__close search-aside-header__icon"
          title="Retour aux résultats"
          aria-hidden="true"
          onClick={closeFilter}
        />
        <span className="search-aside-header__title">
          <FormattedMessage id="search/components/search-aside/SearchMobileHeader.tsx/1" />
          <span className="search-aside-header__count">
            {selectedFiltersLength > 0 && ` (${selectedFiltersLength})`}
          </span>
        </span>
        {selectedFiltersLength > 0 && (
          <button
            type="button"
            className="search-aside-header__clear"
            onClick={resetFilters}
          >
            <FormattedMessage id="search/components/search-aside/SearchMobileHeader.tsx/2" />
          </button>
        )}
      </div>
    );
  }
}
